// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UOCc","toggleWrap":"styles_toggleWrap__3VALa","content":"styles_content__2_XMO","selectAreaCode":"styles_selectAreaCode__1SWSx"};